import { z } from "zod";

export const workflowCheckpointGenerationSchema = z.string().uuid().nullable();
export const workflowApprovalSelectionSchema = z
  .object({ checkpointId: workflowCheckpointGenerationSchema })
  .strict();
export const workflowDocumentReviewSelectionSchema=z.object({documentId:z.string().regex(/^[A-Za-z0-9_-]{1,128}$/),revision:z.string().regex(/^review-[a-f0-9]{64}$/)}).strict();
export const workflowApprovalCommandSchema = z
  .object({
    action: z.enum(["APPROVE", "REJECT"]),
    checkpointId: workflowCheckpointGenerationSchema,
    payload: z.record(z.unknown()).optional(),
    documentReview:workflowDocumentReviewSelectionSchema.optional(),
  })
  .strict()
  .refine(
    (command) => command.action === "REJECT" || command.checkpointId !== null,
  );
export type WorkflowApprovalCommand = z.infer<
  typeof workflowApprovalCommandSchema
>;

export const workflowApprovalResultSchema = z
  .object({ success: z.literal(true) })
  .strict();
export const documentApprovalResultSchema = z
  .object({ message: z.enum(["Approved", "Rejected"]) })
  .strict();
